function Column(_) {
    return null;
}
export { Column };
